import { createApp } from "vue";
import App from "./AppCucumber";
import router from "./router";

let app = createApp(App)

let defaultName = "黄瓜加速"
let appName = !(window.env && window.env.appName) ? defaultName : window.env.appName === '#{APPNAME}' ? defaultName :  window.env.appName
app.config.globalProperties.appName = appName

let defaultCompanyName = "黄瓜加速"
let companyName = !(window.env && window.env.companyName) ? defaultCompanyName : window.env.companyName === '#{COMPANYNAME}' ? defaultCompanyName :  window.env.companyName
app.config.globalProperties.companyName = companyName


let defultEmail = 'viphelp724@gmail.com'
let email = !(window.env && window.env.supportEmail) ? defultEmail : window.env.supportEmail === '#{SUPPORTEMAIL}' ? defultEmail :  window.env.supportEmail
app.config.globalProperties.email = email;

let defaultSlogan = ''
let slogan = !(window.env && window.env.slogan) ? defaultSlogan : window.env.slogan === '#{SLOGAN}' ? defaultSlogan :  window.env.slogan
app.config.globalProperties.slogan = slogan

window.document.title = appName

import utils from "./utils/utils"
utils.statsOpen()

app.use(router).mount("#app");

